module.exports = __webpack_public_path__ + "img/二维码.35cc2b08.png";